module.exports = __webpack_public_path__ + "img/aladdin.1e2e0de6.png";